var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFE15A"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "94.316,0 0,0 0,19.977 94.316,81.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,68.299 0,94.316 39.71,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,161.684 0,187.701 39.71,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,19.977 256,0 161.684,0 161.684,81.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,187.701 256,161.684 216.29,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "161.684,174.23 161.684,256 256,256 256,236.023  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,94.316 256,68.299 216.29,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,236.023 0,256 94.316,256 94.316,174.23  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256,236.023 256,216.059 172.232,161.684 196.98,161.684 256,199.995 256,187.701    216.29,161.684 256,161.684 256,148.21 148.211,148.21 148.211,256 161.684,256 161.684,174.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "0,148.21 0,161.684 39.71,161.684 0,187.701 0,206.602 69.197,161.684 93.945,161.684    0,222.666 0,236.023 94.316,174.23 94.316,256 107.789,256 107.789,148.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "107.789,0 94.316,0 94.316,81.77 0,19.977 0,41.839 80.842,94.316 56.094,94.316 0,57.904    0,68.299 39.71,94.316 0,94.316 0,107.79 107.789,107.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256,107.79 256,94.316 216.29,94.316 256,68.299 256,49.157 186.432,94.316 161.684,94.316    256,33.093 256,19.977 161.684,81.77 161.684,0 148.211,0 148.211,107.79  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "256,148.21 256,107.79 148.211,107.79 148.211,0 107.789,0 107.789,107.79 0,107.79    0,148.21 107.789,148.21 107.789,256 148.211,256 148.211,148.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "69.197,161.684 0,206.602 0,222.666 93.945,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "172.232,161.684 256,216.059 256,199.995 196.98,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "80.842,94.316 0,41.839 0,57.904 56.094,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "186.432,94.316 256,49.157 256,33.093 161.684,94.316  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M160.662,102.774c25.689,40.615-17.273,83.578-57.888,57.888c-2.994-1.894-5.542-4.442-7.435-7.435  c-25.689-40.615,17.273-83.578,57.888-57.888C156.22,97.232,158.768,99.78,160.662,102.774z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M130.221,94.611l6.753,20.248l21.344,0.165c2.763,0.021,3.909,3.548,1.686,5.19l-17.17,12.679   l6.438,20.35c0.834,2.635-2.166,4.814-4.414,3.207l-17.365-12.412l-17.365,12.412c-2.248,1.607-5.248-0.573-4.414-3.207   l6.438-20.35l-17.17-12.679c-2.223-1.642-1.077-5.168,1.686-5.19l21.344-0.165l6.753-20.248   C125.638,91.99,129.346,91.99,130.221,94.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M49.577,110.837l3.631,10.886l11.476,0.089c1.486,0.012,2.102,1.908,0.907,2.79l-9.232,6.817   l3.462,10.941c0.448,1.417-1.165,2.588-2.373,1.724l-9.336-6.673l-9.336,6.673c-1.209,0.864-2.822-0.308-2.373-1.724l3.462-10.941   l-9.232-6.817c-1.195-0.883-0.579-2.779,0.907-2.79l11.476-0.089l3.631-10.886C47.114,109.428,49.107,109.428,49.577,110.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M209.356,110.837l3.631,10.886l11.476,0.089c1.486,0.012,2.102,1.908,0.907,2.79l-9.232,6.817   l3.462,10.941c0.448,1.417-1.165,2.588-2.373,1.724l-9.336-6.673l-9.336,6.673c-1.209,0.864-2.822-0.308-2.373-1.724l3.462-10.941   l-9.232-6.817c-1.195-0.883-0.579-2.779,0.907-2.79l11.476-0.089l3.631-10.886C206.893,109.428,208.886,109.428,209.356,110.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M129.132,29.057l3.631,10.886l11.476,0.089c1.486,0.012,2.102,1.908,0.907,2.79l-9.232,6.817   l3.462,10.941c0.448,1.417-1.165,2.588-2.373,1.724l-9.336-6.673l-9.336,6.673c-1.209,0.864-2.822-0.308-2.373-1.724l3.462-10.941   l-9.232-6.817c-1.195-0.883-0.579-2.779,0.907-2.79l11.476-0.089l3.631-10.886C126.669,27.648,128.662,27.648,129.132,29.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M129.132,194.543l3.631,10.886l11.476,0.089c1.486,0.012,2.102,1.908,0.907,2.79l-9.232,6.817   l3.462,10.941c0.448,1.417-1.165,2.588-2.373,1.724l-9.336-6.673l-9.336,6.673c-1.209,0.864-2.822-0.308-2.373-1.724l3.462-10.941   l-9.232-6.817c-1.195-0.883-0.579-2.779,0.907-2.79l11.476-0.089l3.631-10.886C126.669,193.133,128.662,193.133,129.132,194.543z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNu);
export default __webpack_public_path__ + "static/media/NU.c22493b3b094fd41ea431c5394e6b534.svg";
export { ForwardRef as ReactComponent };